'use strict';

/**
 *
 * Returns a string of the outer html of a jquery element.
 *
 * This is different than `html` because `html`
 * does not return the container e.g. the element
 * itself.
 *
 * @param $
 */
module.exports = function($) {

  $.fn.swOuterHtml = function() {
    return this[0] ? this[0].outerHTML : undefined;
  };

};
